/* po-deposit-note.js — states the Production Deposit split on the product page.

   Spurit's widget offers the choice but never says what the first payment is, so
   the figure only appeared once the shopper reached the cart. This puts it
   directly under the deposit options and above Add to cart, and only while the
   deposit is actually selected.

   The split is not half the total. Spurit defers 50% of the bed at its LIST price
   and takes everything else in full — the Rush Order Upgrade is paid in full at
   order by design — with the whole bundle discount landing on the deferred
   balance. Same arithmetic as snippets/po-cart-savings.liquid, verified against
   live checkouts: $2,032.50 on one bed + Rush, $4,017.20 on two beds + Rush. */
(function () {
  if (window.__poDepositNote) return;
  window.__poDepositNote = true;

  var POLL_MS = 500;

  function money(cents) {
    // The shop renders whole dollars: "${{amount_no_decimals}}".
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }

  function depositChosen() {
    var radio = document.querySelector('input[name="payment-option"]:checked');
    return radio ? !/full/i.test(radio.value) : false;
  }

  // The configurator prices the build pre-discount and reports the bundle saving
  // separately, so take the rate from its own wording rather than re-deriving the
  // threshold here — that rule lives in the section and can change.
  function discountRate(conf) {
    var el = conf.querySelector('[data-poc-bundle-text]');
    var text = el ? el.textContent || '' : '';
    if (!/unlocked/i.test(text)) return 0;
    var pct = text.match(/(\d+)\s*%/);
    return pct ? parseInt(pct[1], 10) / 100 : 0;
  }

  function figures(conf) {
    if (!conf.current || !conf.current.price) return null;

    var field = conf.querySelector('[data-poc-qty]');
    var qty = field ? parseInt(field.value, 10) : 1;
    if (!(qty > 0)) qty = 1;

    var bed = conf.current.price * qty;

    var addons = 0;
    conf.querySelectorAll('input[data-poc-addon]:checked').forEach(function (input) {
      var price = parseInt(input.getAttribute('data-poc-price'), 10);
      if (!(price > 0)) return;
      var row = input.closest('.poc-addon');
      var own = row && row.querySelector('[data-poc-addon-qty]');
      var perBed = input.hasAttribute('data-poc-per-bed');
      var n = perBed ? qty : (own ? parseInt(own.value, 10) : 1);
      addons += price * (n > 0 ? n : 1);
    });

    var keep = 1 - discountRate(conf);
    var today = (bed / 2) + (addons * keep);
    var total = (bed + addons) * keep;

    return { today: today, rest: total - today };
  }

  function build() {
    var node = document.createElement('div');
    node.className = 'po-dep';
    node.setAttribute('data-po-dep', '');
    node.hidden = true;
    node.innerHTML =
      '<span class="po-dep__label">Production deposit</span>' +
      '<p class="po-dep__body"></p>';
    return node;
  }

  // Directly under Spurit's options and above the button, which is where the
  // decision is actually made. Spurit re-inserts its own widget immediately before
  // the button whenever it re-renders, which lifts anything placed earlier above
  // it, so the position is re-asserted rather than set once.
  function place(conf, node) {
    var form = conf.form || conf.querySelector('form[action*="/cart/add"]');
    var atc = form && form.querySelector('[data-poc-atc]');
    if (!form || !atc) return false;
    if (node.parentNode !== form || node.nextElementSibling !== atc) {
      form.insertBefore(node, atc);
    }
    return true;
  }

  // The configurator prints its own deposit sentence into [data-poc-deposit], taken
  // as half the builder subtotal: $5,739 on a cart whose first payment is really
  // $6,026, since it counts neither the bundle discount nor the fact that the 50%
  // is struck on the list price. Two contradictory figures on one screen is worse
  // than one, and ours is the one that matches checkout, so this retires it.
  function hideLegacy(conf) {
    var legacy = conf.querySelector('[data-poc-deposit]');
    if (legacy && !legacy.hidden) legacy.hidden = true;
  }

  function render() {
    var conf = document.querySelector('po-configurator');
    if (!conf || conf.dataset.pocReady !== '1') return;
    hideLegacy(conf);

    var node = conf.querySelector('[data-po-dep]') || build();
    if (!place(conf, node)) return;

    if (!depositChosen()) {
      node.hidden = true;
      return;
    }

    var f = figures(conf);
    if (!f) {
      node.hidden = true;
      return;
    }

    var body = node.querySelector('.po-dep__body');
    var copy =
      'Pay <strong>' + money(f.today) + '</strong> today plus shipping to start your build. ' +
      'The remaining <strong>' + money(f.rest) + '</strong> is charged before your order ships.';

    // Only touch the DOM when the sentence actually changed — Spurit re-renders
    // this form and a needless rewrite fights it.
    if (body.innerHTML !== copy) body.innerHTML = copy;
    node.hidden = false;
  }

  ['change', 'input', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(render, 60); }, true);
  });

  // Selecting a variant or an option mutates no attribute the observer would see,
  // and Spurit re-renders on its own schedule, so keep an idempotent poll as well.
  setInterval(render, POLL_MS);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();